import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser";
import { connect } from "react-redux";
import * as actions from "redux/actions/index";
import { getAuthInfo } from "helper/global";
import Loading from "components/loading/loading";

function Component(props) {
  //
  // hooks

  const { instance, accounts, inProgress } = useMsal();

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;

    const orgId = getAuthInfo().organizationId;
    const request = { scopes: ["User.Read"] };

    async function acquireAndLogin(account) {
      try {
        const response = await instance.acquireTokenSilent({ ...request, account });
        if (response) props.login(orgId, response.idToken);
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          instance.loginRedirect(request).catch(console.error);
        } else {
          console.error(error);
        }
      }
    }

    if (accounts.length > 0) {
      acquireAndLogin(accounts[0]);
    } else {
      instance.loginRedirect(request).catch(console.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instance, accounts, inProgress]);

  // render

  return <Loading />;
}

function mapsDispatchToProps(dispatch) {
  return {
    login: (orgId, token) => dispatch(actions.tokenLogin(orgId, token)),
  };
}

export default connect(null, mapsDispatchToProps)(Component);
